import React, { useMemo, useState } from 'react';
import { Layout, Card, Button, Input, Radio, Collapse, Space, Form, DatePicker } from 'antd';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { useSelector } from 'react-redux';
import CustomThemeDrawer from '../../../../../Elements/CustomThemeDrawer';
import { APIConstants } from '../../../../../../Common/APIConstants';

const { Content } = Layout
const { Panel } = Collapse;
const { RangePicker } = DatePicker;
// import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
import dayjs from 'dayjs';
import * as XLSX from 'xlsx';

// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

const ManuallyEnteredData = () => {
    const [open, setOpen] = useState(false); 
    const [open2, setOpen2] = useState(false); 
    const [form] = Form.useForm();
    const [data, setData] = useState([]);
    const [dates,setDates]=useState([]);
    const [value,setValue]=useState([dayjs().add(-7, 'd'), dayjs()]);
    const [isPanel1Complete, setIsPanel1Complete] = useState(false);
    const [isPanel2Complete, setIsPanel2Complete] = useState(false);
    const [isPanel3Complete, setIsPanel3Complete] = useState(false);
    const [isPanel4Complete, setIsPanel4Complete] = useState(false);
    const showDrawer = () => {
        setOpen(true);
      };
    
      const onClose = () => {
        setOpen(false);
      };
    const showDrawer2 = () => {
        setOpen2(true);
      };

      
    
      const onClose2 = () => {
        setOpen2(false);
      };
      const handleClear = () => {
        form.resetFields();
        onClose() 
        
      };
    const mode = useSelector((state) => state.darkMode);
const color = useSelector((state) => state.ThemeChange);
console.log(color);
const { isdarkMode } = mode;

  
const columnDefs = [
    { headerName: 'Date', field: 'date', width: 150, pinned: 'left', flex:1 },
  
    {
      headerName: 'External Energy Sources',
      children: [
        { headerName: 'Solar', field: 'solar', width: 120, flex:1 },
        { headerName: 'Wind', field: 'wind', width: 120 , flex:1},
      ],
    },
  
    {
      headerName: 'Production Data',
      children: [
        { headerName: 'Crushing', field: 'crushing', width: 120, flex:1 },
        { headerName: 'Tyres', field: 'tyres', width: 120 , flex:1},
      ],
    },
  
    {
      headerName: 'Emission Details',
      children: [
        { headerName: 'HSD', field: 'hsd', width: 120, flex:1 },
        { headerName: 'SKO', field: 'sko', width: 120 , flex:1},
      ],
    },
];
  
const rowData = [
{
    date: '07/01/2025',
    solar: 45,
    wind: 62,
    crushing: 44,
    tyres: 45,
    hsd: 45,
    sko: 443,
},
{
    date: '08/01/2025',
    solar: 34,
    wind: 83,
    crushing: 88,
    tyres: 24,
    hsd: 45,
    sko: 443,
},
];

const handleAddFormChange = (changedValues, allValues) => {
// console.log(allValues?.createdOn?.toISOString())
// const date = new Date(allValues?.createdOn) 
// console.log(generatedISOFormatDateString(new Date (allValues?.createdOn)))

// console.log(dayjs(allValues.createdOn).format("YYYY-MM-DD HH:mm:ss"))
setData({
    ...allValues,
    createdOn: allValues.createdOn,
    // createdOn: allValues.createdOn ? generatedISOFormatDateString(new Date (allValues.createdOn)) : null,
});
// setOpen(false)
};
const handleAddFormSubmit = async () => {
console.log(data)
setOpen(false)
//   try {
//     const url = APIConstants.INSERT_ENERGY_SOURCE_MANUAL_ENTRY;
//     const response = await makeRequest({
//       type: "POST",
//       url: url,
//       body: data,
//     });
//     handleNotification(response.message);
//     handleClear();
//     onClose();
//     setRefetch(!refetch)
//   } catch (err) {
//     console.error(err);
//   }
};
  
const validatePanel = (panelFields, allValues) => {
    return panelFields.every(field => allValues[field] !== undefined && allValues[field] !== null && allValues[field] !== "");
  };
  
  const checkPanel1Completion = (_, allValues, setIsPanel1Complete) => {
    const panel1Fields = ["solar","wind"];
    setIsPanel1Complete(validatePanel(panel1Fields, allValues));
    // setShowMsg1(true)
  };
  
  const checkPanel2Completion = (_, allValues, setIsPanel2Complete) => {
    const panel2Fields = ["tyres","crushing"];
    setIsPanel2Complete(validatePanel(panel2Fields, allValues));
    // setShowMsg1(true)
  };
  
  const checkPanel3Completion = (_, allValues, setIsPanel3Complete) => {
    const panel3Fields = ["hsd", "sko"];
    setIsPanel3Complete(validatePanel(panel3Fields, allValues));
    // setShowMsg2(true)
  };
  const checkPanel4Completion = (_, allValues, setIsPanel4Complete) => {
    const panel4Fields = ["createdOn"];
    setIsPanel4Complete(validatePanel(panel4Fields, allValues));
    // setShowMsg3(true)
  };
  const today = dayjs();
  const startOfWeek = dayjs().weekday(0); // Sunday
  const endOfWeek = dayjs().weekday(6);   // Saturday
  const startOfLastWeek = dayjs().subtract(1, "week").weekday(0);
  const endOfLastWeek = dayjs().subtract(1, "week").weekday(6);
  const startOfMonth = dayjs().startOf("month");
  const endOfMonth = dayjs().endOf("month");
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month");
     
  const rangePresets = [
  //  { label: "Today", value: [today.startOf("day"), today.endOf("day")] },
  //  { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.subtract(1, "day").endOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day"), today] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day"), today] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day"), today] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day"), today] },
  ];
  
  const handleDateChange = (value) => {
    console.log(value)
    if (value) {
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");

      setDates([fromDate, toDate]);
      setValue([value[0], value[1]]);
    } else {
      setDates(null);
    }
  };

const exportTableToExcel = () => {
  const worksheetData = [
    [
      "Date",
      "External Energy Sources", "",  // solar, wind
      "Production Data", "",         // crushing, tyres
      "Emission Details", "",        // hsd, sko
    ],
    [
      "", "Solar", "Wind", "Crushing", "Tyres", "HSD", "SKO"
    ],
    // Actual data rows
    ["07/01/2025", 45, 62, 44, 45, 45, 443],
    ["08/01/2025", 34, 83, 88, 24, 45, 443],
  ];

  const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

  // Merge headers
  worksheet['!merges'] = [
    { s: { r: 0, c: 1 }, e: { r: 0, c: 2 } },  // External Energy Sources
    { s: { r: 0, c: 3 }, e: { r: 0, c: 4 } },  // Production Data
    { s: { r: 0, c: 5 }, e: { r: 0, c: 6 } },  // Emission Details
  ];

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Manual Entry");

  XLSX.writeFile(workbook, "Manual_Entry_Data.xlsx");
};


  console.log(isPanel1Complete)
  console.log(isPanel2Complete)
  console.log(isPanel3Complete)
  console.log(data)
  console.log(dates)
  return (
<div className={`p-4 min-h-screen  ${isdarkMode ? "bg-transparent text-white" : "bg-white text-black"}`}>
  <div>
    <div className="flex justify-between items-center">
    <h2
      className={`pb-0 text-left text-3xl font-[500] ml-0 tracking-[1px] ${
        isdarkMode ? "text-white" : "text-black"
      }`}
    >
      Manual Entry
    </h2>
    <div className="flex gap-3 mb-2">
    <div  className="flex items-center justify-between shadow-2xl border rounded-xl p-1 py-1">
      <h3 className={`${isdarkMode? "text-white":"text-black"}  mt-1`}>Select Date Range:</h3>
      <RangePicker
          presets={rangePresets} 
          value={value}
          // showTime={{ format: "HH:mm" }} // Enables time selection
          format="YYYY-MM-DD "
          onChange={handleDateChange}
          className={`${!isdarkMode? "customRangePicker-light":"customRangePicker-dark "}    w-[300px] ml-2  border border-white `} 
        />
    </div>
    <Button type="primary" onClick={exportTableToExcel}>
  Export to Excel
</Button>

    <Button type="primary" onClick={() => showDrawer()}>Add +</Button>
    </div>
    </div>
 
    <div className="flex gap-4 h-[80vh]">
  <Card
  className={`w-full overflow-hidden  rounded-md shadow ${isdarkMode ? 'bg-transparent' : 'bg-white'}`}
  bodyStyle={{ padding: 0 }}
>
  <div
    className={`${isdarkMode ? "ag-theme-quartz-dark" : "ag-theme-alpine"}`}
    style={{
      '--ag-header-background-color': color.themeConfig.colorPrimary,
      '--ag-header-foreground-color': '#fff',
      '--ag-header-group-bg': color.themeConfig.colorPrimaryShade, // custom var
      height: "80vh", width: "100%", overflowY: "auto"
    }}
    
  >
    <AgGridReact
      columnDefs={columnDefs}
      rowData={rowData}
      domLayout="normal"
      headerHeight={50}
      rowHeight={50}
    />
  </div>
</Card>
</div>

  </div> 

  <CustomThemeDrawer
  title="Close"
  showDrawer={showDrawer}
  open={open}
  onClose={onClose}
>
  <Form
    form={form}
    onFinish={handleAddFormSubmit}
    layout="vertical"
    className="flex flex-col gap-6 mt-2 overflow-y-auto pb-24"
    onValuesChange={(_, allValues) => {
        checkPanel1Completion(_, allValues, setIsPanel1Complete);
        checkPanel2Completion(_, allValues, setIsPanel2Complete);
        checkPanel3Completion(_, allValues, setIsPanel3Complete);
        checkPanel4Completion(_, allValues, setIsPanel4Complete);
        handleAddFormChange(_, allValues);
      }}
  >
    {/* External Energy Sources */}
    {/* <Collapse className={`${isPanel1Complete?"border-green-400":"border-red-400" }  border-l-4  border-t-0`}>
      <Panel header="External Energy Sources" key="1">
        <div className="flex gap-4">
          <Form.Item
            label="Solar"
            name="solar"
            rules={[{ required: true, message: 'Please enter solar value' }]}
            initialValue="23"
            className="w-full text-white"
          >
            <Input placeholder="Enter Solar value"    className={`${isdarkMode ? 'darkmode-input' : ''}  `}/>
          </Form.Item>
          <Form.Item
            label="Wind"
            name="wind"
            rules={[{ required: true, message: 'Please enter wind value' }]}
            initialValue="23"
            className="w-full"
          >
            <Input placeholder="Enter Wind value" />
          </Form.Item>
        </div>
      </Panel>
    </Collapse> */}
    <Collapse
  className={`
    ${isPanel1Complete ? 'border-green-400' : 'border-red-400'}
    border-l-4 border-t-0 rounded-xl transition-all
    ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
  `}
> 
  <Panel
    header="External Energy Sources"
    key="1"
    className={`${isdarkMode ? 'bg-[#1a1a1a] text-white' : ' text-black'}`}
  >
    <div className="flex flex-col md:flex-row gap-4">
      <Form.Item
        label="Solar"
        name="solar"
        rules={[{ required: true, message: 'Please enter solar value' }]}
        initialValue="23"
        className="w-full"
      >
        <Input
          placeholder="Enter Solar value"
          className={`${isdarkMode ? 'darkmode-input' : ''}`}
        />
      </Form.Item>
      <Form.Item
        label="Wind"
        name="wind"
        rules={[{ required: true, message: 'Please enter wind value' }]}
        initialValue="23"
        className="w-full"
      >
        <Input
          placeholder="Enter Wind value"
          className={`${isdarkMode ? 'darkmode-input' : ''}`}
        />
      </Form.Item>
    </div>
  </Panel>
</Collapse>


    {/* Production Data */}
    <Collapse 
    className={`
      ${isPanel1Complete ? 'border-green-400' : 'border-red-400'}
      border-l-4 border-t-0 rounded-xl transition-all
      ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
    `}
    >
      <Panel header="Production Data" key="2">
        <div className="flex gap-4">
        <Form.Item
          label="Crushing"
          name="crushing"
          rules={[{ required: true, message: 'Please enter crushing data' }]}
        >
          <Input placeholder="Enter Crushing Data" className={`${isdarkMode ? 'darkmode-input' : ''}`} />
        </Form.Item>
        <Form.Item
          label="Tyres"
          name="tyres"
          rules={[{ required: true, message: 'Please enter tyres data' }]}
        >
          <Input placeholder="Enter Tyres Data"  className={`${isdarkMode ? 'darkmode-input' : ''}`}/>
        </Form.Item>

        </div>
      </Panel>
    </Collapse>

    {/* Emission Details */}
    <Collapse  className={`
    ${isPanel1Complete ? 'border-green-400' : 'border-red-400'}
    border-l-4 border-t-0 rounded-xl transition-all
    ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
  `}>
      <Panel header="Emission Details" key="3">
        <div className="flex gap-4">
        <Form.Item
          label="HSD"
          name="hsd"
          rules={[{ required: true, message: 'Please enter hsd details' }]}
        >
          <Input placeholder="Enter hsd Details" className={`${isdarkMode ? 'darkmode-input' : ''}`}/>
        </Form.Item>
        <Form.Item
          label="SKO"
          name="sko"
          rules={[{ required: true, message: 'Please enter sko details' }]}
        >
          <Input placeholder="Enter sko Details" className={`${isdarkMode ? 'darkmode-input' : ''}`} />
        </Form.Item>

        </div>
      </Panel>
    </Collapse>
    {/* Emission Details */}
    <Collapse  className={`
    ${isPanel1Complete ? 'border-green-400' : 'border-red-400'}
    border-l-4 border-t-0 rounded-xl transition-all
    ${isdarkMode ? 'dark-collapse' : 'light-collapse'}
  `}>
    <Panel  key="5" header={
        <div className="flex items-center">
          Created On
        </div>
      }>
          <Form.Item label="Created On" name="createdOn" rules={[{ required: true }]}><DatePicker  className={`  ${isdarkMode ? "datebackground dateplaceholder" : "whitemode"} w-80 `}
              dropdownClassName={isdarkMode ? "datedropdown" : "whitemode"} format="YYYY-MM-DD HH:mm:ss" showTime 
              popupClassName="custom-picker"
              // onChange={handleDateChange}
               />
               </Form.Item>
      
      </Panel>
    </Collapse>

    {/* Footer Buttons */}
    <div className="flex justify-between gap-4 w-full absolute bottom-0 right-0 p-4">
      <Button onClick={handleClear}>Cancel</Button>
      <Button htmlType="submit" type="primary" >
        Add
      </Button>
    </div>
  </Form>
</CustomThemeDrawer>
 

  <CustomThemeDrawer
   title="Close"
   showDrawer={showDrawer2}
   open={open2}
   onClose={onClose2}
  >
    <div className="flex flex-col gap-6 mt-2">
        <div>
          <label className="block mb-2 font-medium">
           Add Production Data
          </label>
          <Input
            placeholder="Enter Production Data.."
            // value={alertName}
            // onChange={(e) => setAlertName(e.target.value)}
            className={`${isdarkMode ? 'darkmode-input' : ''}  bg-red-500`}
          />
        </div>

        <div className="flex justify-between gap-4  w-full absolute bottom-0 right-0 p-4">
          <Button onClick={onClose} className="">
            Cancel
          </Button>
          <Button
            type="primary"
            // disabled={!alertName.trim()}
            // onClick={handleAdd}
          >
            Add
          </Button>
        </div>
      </div>
  </CustomThemeDrawer>
</div>

  );
};

export default ManuallyEnteredData;


// <CustomThemeDrawer
//   title="Close"
//   showDrawer={showDrawer}
//   open={open}
//   onClose={onClose}
// >
//   <div className="flex flex-col gap-6 mt-2 overflow-y-auto ">

//     {/* External Energy Sources */}
//     <Collapse className='border-l-4 border-red-400 border-t-0'>
//       <Panel header="External Energy Sources" key="1">
//         <div className="flex  gap-4">
//           <div>
//             <label className="text-sm font-medium">Solar</label>
//             <Input placeholder="Enter Solar value" defaultValue="23" />
//           </div>
//           <div>
//             <label className="text-sm font-medium">Wind</label>
//             <Input placeholder="Enter Wind value" defaultValue="23" />
//           </div>
//         </div>
//       </Panel>
//     </Collapse>

//     {/* Production Data */}
//     <Collapse className='border-l-4 border-red-400 border-t-0'>
//       <Panel header="Production Data" key="2">
//         <div className="flex flex-col gap-2">
//           <label className="text-sm font-medium">Production</label>
//           <Input placeholder="Enter Production Data" />
//         </div>
//       </Panel>
//     </Collapse>

//     {/* Emission Details */}
//     <Collapse className='border-l-4 border-red-400 border-t-0'>
//       <Panel header="Emission Details" key="3">
//         <div className="flex flex-col gap-2">
//           <label className="text-sm font-medium">Emissions</label>
//           <Input placeholder="Enter Emission Details" />
//         </div>
//       </Panel>
//     </Collapse>

//     {/* Footer Buttons */}
//     <div className="flex justify-between gap-4 w-full absolute bottom-0 right-0 p-4 bg-white">
//       <Button onClick={onClose}>Cancel</Button>
//       <Button type="primary">Add</Button>
//     </div>
//   </div>
// </CustomThemeDrawer>